<template>
  <div class="shenyunjie-chart-gradienter" :id="id"></div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import DarkUnica from "../../theme/charts/highcharts-dark-unica.js";
import merge from "deepmerge";
HighchartsMore(Highcharts);

export default {
  name: "YunJieChartGradienter",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        accessibility: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        chart: {
          marginTop: 32,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          polar: true
        },
        pane: {
          startAngle: -90,
          endAngle: 270
        },
        title: {
          style: {
            color: "#5470C6",
            fontWeight: "bold"
          }
        },
        subtitle: {
          verticalAlign: "middle",
          style: {
            fontWeight: "bold"
          }
        },
        tooltip: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        yAxis: [{
          min: 0,
          max: 10,
          gridLineWidth: 0,
          tickWidth: 0,
          minorGridLineWidth: 0,
          minorTickWidth: 0,
          lineWidth: 0,
          labels: {
            enabled: false
          }
        }, {
          min: 0,
          max: 10,
          gridLineWidth: 0,
          tickWidth: 0,
          minorGridLineWidth: 0,
          minorTickWidth: 0,
          lineWidth: 0,
          labels: {
            enabled: false
          }
        }],
        xAxis: {
          tickInterval: 45,
          min: 0,
          max: 360,
          labels: {
            formatter: function () {
              if (this.value > 180) {
                return `-${360 - this.value}°`;
              } else if (this.value % 180 == 0) {
                return `±${this.value}°`;
              }
              return `+${this.value}°`;
            }
          }
        },
        plotOptions: {
          column: {
            animation: false,
            borderWidth: 0,
            shadow: false,
            grouping: false,
            pointPlacement: 0,
            pointPadding: 0,
            groupPadding: 0
          },
          series: {
            pointInterval: 180,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                opacity: 1
              }
            }
          }
        },
        series: [{
          type: "column",
          name: "倾角",
          data: [10, 0],
          pointPlacement: "between",
          yAxis: 1
        }]
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.destroy();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 合并主题
        let theme = self.theme || (this.$YunJie || {}).theme || "standard";
        let opt = merge({}, self.defaultOption);
        if (theme == "darkness") {
          let _DarkUnica = merge({}, DarkUnica);
          let _yAxis = _DarkUnica.yAxis;
          delete _DarkUnica.yAxis;
          opt = merge(opt, _DarkUnica);
          opt.yAxis[0] = merge(opt.yAxis[0], _yAxis);
          opt.yAxis[1] = merge(opt.yAxis[1], _yAxis);
        }
        // 配置汇总
        let parameter = {
          title: {
            text: self.title
          },
          subtitle: {
            text: self.value > 0 ? `+${self.value}°` : `${self.value}°`
          }
        };
        opt = merge(opt, parameter);
        let v = (self.value + 180) % 360;
        if (v < 0) {
          v = v + 360;
        }
        opt.series[0].pointStart = v;
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        if (!self.chart) {
          self.chart = Highcharts.chart(self.id, opt);
        } else {
          self.chart.update(opt);
        }
      }
    }
  },
  destroyed() {
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    value() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-gradienter {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/gradienter.vue